const faArrowIcons = [
    "fas fa-arrow-alt-circle-left",
    "far fa-arrow-alt-circle-left",
    "fas fa-arrow-alt-circle-right",
    "far fa-arrow-alt-circle-right",
    "fas fa-arrow-circle-left",
    "fas fa-arrow-circle-right",
    "fas fa-arrow-left",
    "fas fa-arrow-right",
    "fas fa-long-arrow-alt-left",
    "fas fa-long-arrow-alt-right",
	"fas fa-chevron-circle-left",
	"fas fa-chevron-circle-right",
	"fas fa-chevron-left",
	"fas fa-chevron-right",
	"fas fa-caret-left",
	"fas fa-caret-right",
	"fas fa-caret-square-left",
	"far fa-caret-square-left",
	"fas fa-caret-square-right",
	"far fa-caret-square-right",
	"fas fa-chevron-circle-down",
	"fas fa-chevron-circle-up",
	"fas fa-chevron-down",
	"fas fa-chevron-up",
    "fas fa-arrow-alt-circle-down",
    "far fa-arrow-alt-circle-down",
    "fas fa-arrow-alt-circle-up",
    "far fa-arrow-alt-circle-up",
    "fas fa-arrow-circle-down",
    "fas fa-arrow-circle-up",
    "fas fa-arrow-down",
    "fas fa-arrow-up",
    "fas fa-long-arrow-alt-down",
    "fas fa-long-arrow-alt-up",
	"fas fa-caret-down",
	"fas fa-caret-square-down",
	"far fa-caret-square-down",
	"fas fa-caret-square-up",
	"far fa-caret-square-up",
	"fas fa-caret-up",
    "fas fa-arrows-alt-h",
    "fas fa-arrows-alt-v",
    "fas fa-arrows-alt",
];

export default faArrowIcons;
